import { combineReducers } from "redux";

import { loginReducer } from "../../login/login/actions";
import { userDashboardReducer } from "../../dashboard/user/actions";
import { cssDashboardReducer } from "../../superadmin/actions";
import { adminPaymentsReducer } from "../../superadmin/payments-reducer";
import { adminSymbolsReducer } from "../../superadmin/symbols-reducer";
import { onboardingReducer } from "../../onboarding/actions";
import { appReducer } from "../../app/actions";
import { navigateReducer } from "../../nav/actions";
import { clientReducer } from "./client";
import { dwollaReducer } from "../../payment/actions";
import { tdaReducer } from "../../tda/actions";
import { governorReducer } from "../../governor/actions";
import { inboxReducer } from "../../inbox/actions";
import { chatReducer } from "../../chat/actions";
import { adminIRRReducer } from "../../superadmin/irr-reducer";
import {adminNotificationReducer} from "../../superadmin/notification-reducer";
import { adminPortfolioReducer } from "../../superadmin/portfolio-reducer";
import { wlfs_reducer } from "../../superadmin/wlfs-reducer";
import { CDOfferingReducer } from "../../cd/CurrentOfferings/actions";
import {securityPurchaseReducer} from "../../superadmin/security-purchase-reducer";
import {userPaymentsReducer} from "../../components/PaymentsDashboard/action";
import {testReducer} from "./test-reducer";
import {adminUserDashboardReducer} from "../../components/SA_UserPortfolios/reducer";

export const makeRootReducer = (asyncReducers) => {
  return combineReducers({

    app: appReducer,
    chat: chatReducer,
    client: clientReducer,
    cssDashboard: cssDashboardReducer,
    cdOffering: CDOfferingReducer,
    dwolla: dwollaReducer,
    governor: governorReducer,
    inbox: inboxReducer,
    irr: adminIRRReducer,
    notification: adminNotificationReducer,
    onboarding: onboardingReducer,
    path: navigateReducer,
    paymentsReducer: adminPaymentsReducer,
    portfolio: adminPortfolioReducer,
    securityPurchase: securityPurchaseReducer,
    symbols: adminSymbolsReducer,
    tda: tdaReducer,
    user: loginReducer,
    userDashboard: userDashboardReducer,
    adminUserDashboard: adminUserDashboardReducer,
    userPayments: userPaymentsReducer,
    testRuns: testReducer,
    wlfs: wlfs_reducer,

    ...asyncReducers
  });
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(
    makeRootReducer(store.asyncReducers)
  );
};

export default makeRootReducer;
